export default function findInstagramIdentity<T extends { platform: string }>(
  identities: T[]
) {
  return identities.find((i) => i.platform.startsWith('instagram_'));
}
